var _classCallCheck = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var EventEmitter = require('events');

var Tracker = /*#__PURE__*/function (_EventEmitter) {
  "use strict";

  _inherits(Tracker, _EventEmitter);

  function Tracker(client, announceUrl) {
    var _this;

    _classCallCheck(this, Tracker);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Tracker).call(this));
    _this.client = client;
    _this.announceUrl = announceUrl;
    _this.interval = null;
    _this.destroyed = false;
    return _this;
  }

  _createClass(Tracker, [{
    key: "setInterval",
    value: function (_setInterval) {
      function setInterval(_x) {
        return _setInterval.apply(this, arguments);
      }

      setInterval.toString = function () {
        return _setInterval.toString();
      };

      return setInterval;
    }(function (intervalMs) {
      var _this2 = this;

      if (intervalMs == null) intervalMs = this.DEFAULT_ANNOUNCE_INTERVAL;
      clearInterval(this.interval);

      if (intervalMs) {
        this.interval = setInterval(function () {
          _this2.announce(_this2.client._defaultAnnounceOpts());
        }, intervalMs);
        if (this.interval.unref) this.interval.unref();
      }
    })
  }]);

  return Tracker;
}(EventEmitter);

module.exports = Tracker;